import Analytics from './Analytics.component';
import Header from './Header.component';
import StoreHeader from './StoreHeader.component';

export default {
	Analytics,
	Header,
	StoreHeader,
};
